import { useEffect, useState } from "react";

// Openingstijden (minuten sinds middernacht) — Europe/Amsterdam
// 07:00=420, 18:00=1080, 08:00=480
const HOURS = { 1: [420, 1080], 2: [420, 1080], 3: [420, 1080], 4: [420, 1080], 5: [420, 1080], 6: [480, 1080] };
const DAY_NAMES = ["zo", "ma", "di", "wo", "do", "vr", "za"];

const fmtMin = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;

function amsNow() {
  const fmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Amsterdam",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const p = Object.fromEntries(fmt.formatToParts(new Date()).map((x) => [x.type, x.value]));
  const days = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
  return { day: days[p.weekday], minutes: parseInt(p.hour, 10) * 60 + parseInt(p.minute, 10) };
}

export function getOpenStatus() {
  const { day, minutes } = amsNow();
  const today = HOURS[day];
  if (today && minutes >= today[0] && minutes < today[1]) {
    return { open: true, text: `Nu open · tot ${fmtMin(today[1])}` };
  }
  if (today && minutes < today[0]) {
    return { open: false, text: `Gesloten · opent vandaag ${fmtMin(today[0])}` };
  }
  for (let i = 1; i <= 7; i++) {
    const d = (day + i) % 7;
    if (HOURS[d]) return { open: false, text: `Gesloten · opent ${DAY_NAMES[d]} ${fmtMin(HOURS[d][0])}` };
  }
  return { open: false, text: "Gesloten" };
}

export const OpenStatus = ({ className = "", variant = "light" }) => {
  const [status, setStatus] = useState(getOpenStatus());

  useEffect(() => {
    const id = setInterval(() => setStatus(getOpenStatus()), 60000);
    return () => clearInterval(id);
  }, []);

  const isDark = variant === "dark";
  return (
    <div
      data-testid="open-status"
      className={`inline-flex items-center gap-2 rounded-full text-xs font-semibold px-3 py-1.5 border ${
        isDark ? "border-white/20 text-white/90" : "border-black/10 bg-white/60 text-text-main"
      } ${className}`}
    >
      <span className="relative flex h-2 w-2">
        {status.open && (
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
        )}
        <span className={`relative inline-flex rounded-full h-2 w-2 ${status.open ? "bg-emerald-500" : "bg-red-400"}`} />
      </span>
      {status.text}
    </div>
  );
};
